import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'ebb-portal-dialog-confirm-message',
    templateUrl: './dialog-confirm-message.component.html',
    standalone: false
})
export class DialogConfirmMessageComponent implements OnInit {
  message: string;
  buttonlabel:string;
  buttonCancelLabel:string;
  
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.buttonCancelLabel = data.buttonCancelLabel;
    this.message = data.message;
    this.buttonlabel = data.buttonlabel;
  }

  ngOnInit() {}

  onClickCancel(): void {
    this.dialogRef.close(0);
  }

  onClickClose(): void {
    this.dialogRef.close(1);
  }
}
